module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxShow),
      expression: "wxShow"
    }],
    staticClass: "wx-load-c",
    staticStyle: {
      "width": "100%",
      "height": "100"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin": "20px",
      "font-size": "30px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-close"
    },
    on: {
      "click": _vm.wxClose
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "160px"
    },
    attrs: {
      "id": "login_container2"
    }
  })]), _vm._v(" "), _c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "container ac"
  }, [_c('h1', [_vm._v("账号设置")]), _vm._v(" "), _c('div', {
    staticClass: "ab"
  }, [_c('h2', [_vm._v("用户资料")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal smart-wizard",
    staticStyle: {
      "padding-left": "340px",
      "position": "relative"
    },
    attrs: {
      "id": "fileupload",
      "action": "jf/platform/sdContent/save",
      "method": "POST",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "position": "absolute",
      "left": "220px",
      "top": "0"
    }
  }, [(Object.keys(_vm.state).length > 0) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.state.data.faceUrl,
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(Object.keys(_vm.state).length > 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickName),
      expression: "nickName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.state.data.nickName
    },
    domProps: {
      "value": (_vm.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.changeName()
      }
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('div', {
    staticClass: "ab"
  }, [_c('h2', [_vm._v("第三方登录")]), _vm._v(" "), _c('p', {
    staticClass: "sf"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/wechat-hover.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.state.data.unionId) ? _c('span', {
    staticStyle: {
      "margin": "0 20px",
      "display": "inline-block",
      "margin-left": "74px"
    }
  }, [_vm._v("已绑定")]) : _vm._e(), _vm._v(" "), (!_vm.state.data.unionId) ? _c('span', {
    staticStyle: {
      "margin": "0 20px",
      "display": "inline-block",
      "margin-left": "74px"
    }
  }, [_vm._v("未绑定")]) : _vm._e(), _vm._v(" "), (_vm.state.data.unionId) ? _c('span', {
    staticStyle: {
      "color": "#3E87FF",
      "cursor": "pointer",
      "margin-left": "149px"
    },
    on: {
      "click": _vm.unBindWeixin
    }
  }, [_vm._v("去解绑")]) : _vm._e(), _vm._v(" "), (!_vm.state.data.unionId) ? _c('span', {
    staticStyle: {
      "color": "#3E87FF",
      "cursor": "pointer",
      "margin-left": "149px"
    },
    on: {
      "click": _vm.goBindWx
    }
  }, [_vm._v("去绑定")]) : _vm._e()]), _vm._v(" "), (false) ? _c('p', {
    staticClass: "sf"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/qq-hover.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px",
      "margin": "0 20px",
      "display": "inline-block"
    }
  }, [_vm._v("未绑定")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3E87FF"
    }
  }, [_vm._v("去绑定")])]) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticClass: "sf"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/weibo-hover.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px",
      "margin": "0 20px",
      "display": "inline-block"
    }
  }, [_vm._v("未绑定")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3E87FF"
    }
  }, [_vm._v("去绑定")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ab",
    staticStyle: {
      "border": "none"
    }
  }, [_c('h2', [_vm._v("账号安全")]), _vm._v(" "), _c('p', {
    staticClass: "sf"
  }, [_c('span', {
    staticStyle: {
      "width": "60px",
      "margin-right": "20px",
      "display": "inline-block"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('span', {
    staticStyle: {
      "width": "100px",
      "margin": "0 20px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm._f("phoneCard")(_vm.state.data.account)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3E87FF",
      "cursor": "pointer",
      "margin-left": "93px"
    },
    on: {
      "click": function($event) {
        _vm.modal1 = true
      }
    }
  }, [_vm._v("修改")])]), _vm._v(" "), _c('p', {
    staticClass: "sf"
  }, [_c('span', {
    staticStyle: {
      "width": "60px",
      "margin-right": "20px",
      "display": "inline-block"
    }
  }, [_vm._v("账号密码")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px",
      "margin": "0 20px",
      "display": "inline-block"
    }
  }, [_vm._v("******")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3E87FF",
      "cursor": "pointer",
      "margin-left": "93px"
    },
    on: {
      "click": function($event) {
        _vm.modify.setPsd = true
      }
    }
  }, [_vm._v("修改密码")])]), _vm._v(" "), _c('p', {
    staticClass: "sf"
  }, [_c('span', {
    staticStyle: {
      "width": "60px",
      "margin-right": "20px",
      "display": "inline-block"
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('span', {
    staticStyle: {
      "width": "100px",
      "margin": "0 20px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.state.data.email || '暂未绑定'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3E87FF",
      "cursor": "pointer",
      "margin-left": "93px"
    },
    on: {
      "click": function($event) {
        return _vm.openEmail()
      }
    }
  }, [_vm._v("绑定邮箱")])])])]), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('Modal', {
    attrs: {
      "title": "修改手机号",
      "width": "400",
      "footer-hide": ""
    },
    on: {
      "on-ok": _vm.ok,
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.modal1),
      callback: function($$v) {
        _vm.modal1 = $$v
      },
      expression: "modal1"
    }
  }, [(_vm.tep) ? _c('div', [(Object.keys(_vm.state).length > 0) ? _c('h2', {
    staticStyle: {
      "font-size": "14px",
      "color": "#424753"
    }
  }, [_vm._v("原手机号：" + _vm._s(_vm.state ? _vm.state.data.account : 0))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticStyle: {
      "width": "230px",
      "vertical-align": "bottom"
    },
    attrs: {
      "type": "text",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "get-btn",
    on: {
      "click": function($event) {
        return _vm.getMobileSms()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "get-btn"
  }, [_vm._v(_vm._s(_vm.count) + "s")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "margin-left": "calc(50% - 75px)",
      "margin-top": "40px",
      "margin-bottom": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.changeSms()
      }
    }
  }, [_vm._v("下一步")])]) : _vm._e(), _vm._v(" "), (!_vm.tep) ? _c('div', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "新手机号不能与旧手机号相同"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": function($event) {
        return _vm.newOld()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.fs) ? _c('span', {
    staticStyle: {
      "display": "block",
      "color": "#e4393c",
      "padding-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.phoneMsg))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code2),
      expression: "code2"
    }],
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "text",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.code2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }],
    staticClass: "get-btn",
    staticStyle: {
      "width": "86px"
    },
    on: {
      "click": function($event) {
        return _vm.getMobileSms('1987')
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm2))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show2),
      expression: "!show2"
    }],
    staticClass: "get-btn",
    staticStyle: {
      "width": "86px"
    }
  }, [_vm._v(_vm._s(_vm.count2) + "s")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "margin-left": "calc(50% - 75px)",
      "margin-top": "40px",
      "margin-bottom": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.changePhone()
      }
    }
  }, [_vm._v("绑定")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('Modal', {
    attrs: {
      "title": "设置安全密码",
      "width": "600",
      "footer-hide": ""
    },
    on: {
      "on-ok": _vm.ok,
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.modify.setPsd),
      callback: function($$v) {
        _vm.$set(_vm.modify, "setPsd", $$v)
      },
      expression: "modify.setPsd"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "600px",
      "height": "460px",
      "margin-left": "-20px"
    }
  }, [_c('p', {
    staticClass: "center-p"
  }, [_c('label', [_vm._v("手机号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("phoneCard")(_vm.state.data.account)))])]), _vm._v(" "), _c('p', {
    staticClass: "center-p"
  }, [_c('label', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "8px"
    }
  }, [_vm._v("手机验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modify.code),
      expression: "modify.code"
    }],
    staticClass: "yzm-ipt",
    staticStyle: {
      "width": "269px",
      "height": "40px",
      "line-height": "40px",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.modify.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modify, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modify.show),
      expression: "modify.show"
    }],
    staticClass: "get-yzm",
    staticStyle: {
      "vertical-align": "middle",
      "width": "111px",
      "height": "40px",
      "line-height": "40px",
      "border": "1px solid #ddd",
      "margin-left": "20px",
      "float": "right",
      "text-align": "center",
      "display": "block"
    },
    on: {
      "click": function($event) {
        return _vm.getYzm()
      }
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.modify.show),
      expression: "!modify.show"
    }],
    staticClass: "get-yzm",
    staticStyle: {
      "vertical-align": "middle",
      "width": "111px",
      "height": "40px",
      "line-height": "40px",
      "border": "1px solid #ddd",
      "margin-left": "20px",
      "float": "right",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.modify.count) + "s")])]), _vm._v(" "), _c('p', {
    staticClass: "center-p"
  }, [_c('label', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "8px"
    }
  }, [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modify.password),
      expression: "modify.password"
    }],
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.modify.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modify, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center-p"
  }, [_c('label', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "8px"
    }
  }, [_vm._v("重复新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modify.confirmPassword),
      expression: "modify.confirmPassword"
    }],
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码"
    },
    domProps: {
      "value": (_vm.modify.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.modify, "confirmPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center-p",
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "150px",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.savePsd()
      }
    }
  }, [_vm._v("确认提交")])])])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.state).length > 0) ? _c('Modal', {
    attrs: {
      "title": "绑定邮箱",
      "width": "400",
      "footer-hide": ""
    },
    on: {
      "on-ok": _vm.ok,
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.email.show),
      callback: function($$v) {
        _vm.$set(_vm.email, "show", $$v)
      },
      expression: "email.show"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "height": "160px",
      "margin-left": "-16px",
      "margin-top": "20px"
    }
  }, [_c('p', {
    staticClass: "center-p",
    staticStyle: {
      "width": "300px",
      "margin": "0 auto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.email),
      expression: "email.email"
    }],
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.email.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center-p",
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "150px",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.postEmail()
      }
    }
  }, [_vm._v("发送验证邮箱")])])])]) : _vm._e(), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-2"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#424753"
    }
  }, [_vm._v("支持上传JPG\\PNG或GIF格式图片文件，文件大小不能超过250KB")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#424753"
    }
  }, [_vm._v("建议上传尺寸 200 X 200 像素")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-danger delete-row btn-empty",
    staticStyle: {
      "color": "#000000",
      "background": "#FFFFFF",
      "border": "1px solid #D8D8D8",
      "border-radius": "2px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "button",
      "id": "selectVideoPhoto"
    }
  }, [_vm._v("上传头像")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "content.video_photo",
      "val": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f12e1d3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/account.vue
// module id = 1306
// module chunks = 34